export enum TipoValidacaoEstoqueNegativoEnum {
  Sim = 1,
  TodosDepositos = 2,
  DepositoSelecionado = 3,
}
